import React from 'react'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { ThemeColor } from 'utils/themes/types'

type CoachOnboardingPromptProps = {
  title?: string
  subtitle?: string
  color?: ThemeColor
}
export const CoachOnboardingPrompt = ({
  title,
  subtitle,
  color = 'white',
}: CoachOnboardingPromptProps) => {
  return (
    <Box testID='CoachOnboardingPrompt' align='center' margin='md'>
      <Box flexDirection='row'>
        <Text bold color={color} fontSize='md' align='center'>
          {title}
        </Text>
      </Box>
      {subtitle && (
        <Box flexDirection='row' margin={{ top: 'sm' }}>
          <Text color={color} fontSize='sm' align='center'>
            {subtitle}
          </Text>
        </Box>
      )}
    </Box>
  )
}
